import { RouteFieldName } from "@app/util/fieldModel/RouteFieldModel";

// First-run defaults only. A persisted resize wins, and a first-time visitor gets
// these fitted to the viewport. Everything else about a column lives on its field.
const COLUMN_WIDTHS: Partial<Record<RouteFieldName, number>> = {
  [RouteFieldName.ACTIONS]: 56,
  [RouteFieldName.COUNT]: 100,
  // fits the bar plus its trailing percentage
  [RouteFieldName.PROGRESS]: 220,
  [RouteFieldName.START_AT]: 200,
  [RouteFieldName.STATUS]: 140,
  [RouteFieldName.TOTAL_DISTANCE]: 120,
  // fits a multi-day duration, which formats as "3d 14h 31m"
  [RouteFieldName.TOTAL_DURATION]: 160,
  // fits an avatar plus a display name that is often an email address
  [RouteFieldName.USER]: 260,
};

export default COLUMN_WIDTHS;
